import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

/** Un componente rotto non deve mai lasciare la pagina completamente bianca. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-serif text-2xl text-ink">Si è verificato un errore</p>
          <a href="/" className="text-sm font-semibold text-bordeaux underline">
            Torna alla Home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}
